import { render, staticRenderFns } from "./AppointmentArrow.vue?vue&type=template&id=266f47be"
import script from "./AppointmentArrow.vue?vue&type=script&lang=js"
export * from "./AppointmentArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports